import { NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, inject } from '@angular/core';

import { CountdownTypes } from '@modules/countdown/enums/countdown-types.enum';

import { CountdownComponent } from '../../../../countdown/countdown/countdown.component';

@Component({
  selector: 'mb-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, CountdownComponent],
})
export class AnnouncementComponent {
  private cdr = inject(ChangeDetectorRef);

  public countDownReached = false;

  private _countdownDate: Date | null = null;

  countdownType = CountdownTypes;

  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() showDaysOnly = true;

  @Input()
  set countdownDate(d: Date | null) {
    this._countdownDate = d;
    if (d) {
      if (d.getTime() < Date.now()) {
        this.countDownReached = true;
      } else {
        this.countDownReached = false;
      }
    }
  }
  get countdownDate() {
    return this._countdownDate;
  }
  @Input() countdownLabel: string = '';
  @Input() postCountdownLabel: string = '';
  @Input() isBelowCountdown: boolean = false;

  public finished() {
    this.countDownReached = true;
    this.cdr.detectChanges();
  }
}
